enum WorkSummaryBillingType {
	BILLABLE_WORK = 'BILLABLE_WORK',
	MATERIAL_COST = 'MATERIAL_COST'
}

export default WorkSummaryBillingType;
